export const isStaging = [
  "pvcalc-staging.dts.corp.local",
  "pvcalcdev.alzp.tgscloud.net",
].includes(window.location.hostname);
